import React, { useEffect, useRef, useState } from 'react';

import SearchSVG from '../svg/icons/search.svg';

const DocsSearch = () => {
  const [value, setValue] = useState('');
  const search = useRef(null);

  useEffect(() => {
    if (typeof docsearch !== 'undefined') {
      search.current = window.docsearch({
        apiKey: process.env.GATSBY_ALGOLIA_KEY,
        indexName: 'graphcms',
        inputSelector: '#docsearch-input',
        autocompleteOptions: {
          openOnFocus: true,
        },
      });
    }
  }, []);

  const onChange = (event) => setValue(event.target.value);

  return (
    <div className="relative">
      <SearchSVG className="-translate-y-1/2 absolute inset-y-1/2 mx-2 text-cornflower transform w-5 z-10" />
      <input
        id="docsearch-input"
        className="bg-transparent border-none text-primary-400 text-lg font-medium pl-10 pr-3 py-2 w-full focus:outline-none active:focus-none"
        onChange={onChange}
        value={value}
        placeholder="Search GraphCMS Docs"
      />
    </div>
  );
};

export default DocsSearch;
